import { FormattedMessage } from 'react-intl';
import { Col, Row, Statistic } from 'antd';
import { useColorScheme } from '@/contexts/ColorSchemeContextProvider';
import formatterPrice from '@/utils/number/formatterPrice';

interface WorkOrderItemsSummaryProps {
  partTotal?: number;
  serviceTotal?: number;
  total?: number;
}

function WorkOrderItemsSummary({
  partTotal,
  serviceTotal,
  total,
}: WorkOrderItemsSummaryProps) {
  const [colorScheme] = useColorScheme();

  return (
    <Row style={{ marginTop: 24 }} gutter={24}>
      <Col flex="1">
        <Statistic
          title={<FormattedMessage id="workOrders.details.items.partTotal" />}
          valueRender={() => formatterPrice(partTotal || 0)}
          valueStyle={{ color: colorScheme === 'light' ? '#364068' : '#fff' }}
          style={{
            whiteSpace: 'nowrap',
          }}
        />
      </Col>
      <Col flex="1">
        <Statistic
          title={
            <FormattedMessage id="workOrders.details.items.serviceTotal" />
          }
          valueRender={() => formatterPrice(serviceTotal || 0)}
          valueStyle={{ color: colorScheme === 'light' ? '#364068' : '#fff' }}
          style={{
            whiteSpace: 'nowrap',
          }}
        />
      </Col>
      <Col flex="1">
        <Statistic
          title={<FormattedMessage id="workOrders.details.items.total" />}
          valueRender={() => formatterPrice(total || 0)}
          valueStyle={{ color: '#38B3CA' }}
          style={{
            whiteSpace: 'nowrap',
          }}
        />
      </Col>
    </Row>
  );
}

export default WorkOrderItemsSummary;
